import { http } from '@/shared/http.ts'

export const postStartTask = async (token: string, task_id: number) => {
  return await http.post(
    '/tasks/check-task',
    {
      token,
      body: {
        task_id
      },
    },
  )
}


export const getTasks = async (token: string) => {
  // TODO: clarify this type
  return await http.get<any>('/tasks/', {
    token,
  })
}



export const postClaimTaskRewrd = async (token: string, task_id: number) => {
  return await http.post(
    '/tasks/claim/',
    {
      token,
      body: {
        task_id,
      }
    },
  )
}